export interface ChefInfo {
  id: string;
  name: string;
  title: string;
  description: string;
  points: string[];
}

export const parseChefMarkdown = (markdown: string): Record<string, ChefInfo> => {
  const chefs: Record<string, ChefInfo> = {};
  if (!markdown) return chefs;

  const sections = markdown.split('## ').slice(1);

  sections.forEach(section => {
    const lines = section.trim().split('\n').filter(line => line.trim() !== '');
    if (lines.length < 2) return;

    const title = lines[0].trim();
    const id = title.replace(/[^a-zA-Z0-9]/g, '');
    const description = lines[1].trim();
    const points = lines.slice(2).map(line => line.replace(/^[*-]\s*/, '').trim()).filter(Boolean);

    chefs[id] = {
      id,
      name: title,
      title,
      description,
      points,
    };
  });

  return chefs;
};
